import styled from "styled-components";
import { LazyImage } from "@crehana/ui";
export var AcademyCardContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ibw69p-0"
})(["\n  ", "\n  ", "\n    border-radius: 20px;\n"], function (_ref) {
  var theme = _ref.theme;
  return "\n        height: 240px;\n        ".concat(theme.breakpoints.up('sm'), " {\n          height: 192px;\n        }\n        ").concat(theme.breakpoints.up('lg'), " {\n          height: 240px;\n        }\n      ");
}, function (_ref2) {
  var isDark = _ref2.isDark;
  return !isDark && '  box-shadow: 0px 8px 20px rgba(195, 203, 214, 0.18),0px 0px 16px rgba(195, 203, 214, 0.24);';
});
export var AcademyCardOverlay = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ibw69p-1"
})(["\n  ", "\n"], function (_ref3) {
  var isDark = _ref3.isDark;
  return isDark ? 'background: linear-gradient(180deg, rgba(156, 134, 249, 0) 50%, rgba(156, 134, 249, 0.2) 100%), rgba(255, 255, 255, 0.08);' : "\n      background: linear-gradient(\n        180deg,\n        rgba(156, 134, 249, 0) 50%,\n        rgba(156, 134, 249, 0.2) 100%\n      ),\n      #ffffff;\n  ";
});
export var AcademyCardContainerSkeleton = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-ibw69p-2"
})(["\n  ", "\n  border-radius: 20px;\n"], function (_ref4) {
  var theme = _ref4.theme;
  return "\n        height: 240px;\n        ".concat(theme.breakpoints.up('sm'), " {\n          height: 192px;\n        }\n        ").concat(theme.breakpoints.up('lg'), " {\n          height: 240px;\n        }\n      ");
});
export var LazyImageComponent = /*#__PURE__*/styled(LazyImage).withConfig({
  componentId: "sc-ibw69p-3"
})(["\n  ", "\n"], function (_ref5) {
  var theme = _ref5.theme;
  return "\n    width: 160px;\n    height: 160px;\n    ".concat(theme.breakpoints.up('sm'), " {\n      width: 120px;\n      height: 120px;\n    }\n    ").concat(theme.breakpoints.up('lg'), " {\n      width: 160px;\n      height: 160px;\n    }\n  ");
});